module.exports = __webpack_public_path__ + "img/social_responsibility_book_run.44489508.jpg";